// Copyright (c) 2016 Deere & Company

import {
    exportMachineStatusUpdates,
    readMachineStatusUpdates
} from './get-machine-status-updates';
import {
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateFacetsDeliveryDateRange,
    updateFacetsRegistrationDateRange
} from './facets.js';
import {deleteMachineStatus} from './delete-machine-update.js';
import {exportToExcel} from './export-to-excel.js';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined.js';
import {highRentalDaysExportToExcel} from '../../shared/action-creators/high-rental-days-export-to-excel.js';
import sharedActionCreators from '../../shared/action-creators/index.js';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion.js';
import {updateFactoryDuplicatePinPlateResults} from '../../factory-users-duplicate-pin-plate/action-creators/factory-duplicate-pin-plates.js';
import {updateRegistrationResults} from './registration.js';
import {updateTransferResultsWithFacets} from '../../transfers/action-creators/facet-updates.js';

export default {
    ...exportToExcelActions,
    ...sharedActionCreators,
    deleteMachineStatus,
    exportMachineStatusUpdates,
    exportToExcel,
    highRentalDaysExportToExcel,
    readMachineStatusUpdates,
    selectAllDealersOnInitialLoad,
    toggleDealerAccountFacetItems,
    toggleReportsAccordion,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateFacetsDeliveryDateRange,
    updateFacetsRegistrationDateRange,
    updateFactoryDuplicatePinPlateResults,
    updateRegistrationResults,
    updateTransferResultsWithFacets
};



// WEBPACK FOOTER //
// ./src/product/machine-status-update/action-creators/index.js